import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import { layout } from "../../../_App/Redux/Slices/Caisse/CaisseSlice";
import {
  Currentpage,
  ListOnlineOrders,
  ListOrders,
  Recette,
  Remboursement,
  TotalNet,
  TotalPages,
  TotalTTC,
  findFiltreSoldProductsApi,
  findOrdersFiltreApi,
  resetSelectedOrder,
  selectOrder,
  totalRemises,
  updateOrderApi,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  SelectedOrganisation,
  SelectedOrganisationId,
  selectUser,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { formatdate, statusList } from "../../../_App/Helpers/helpers";
import flatpickr from "flatpickr";
import { useTranslation } from "react-i18next";
import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { findPaymentsByOrderApi } from "../../../_App/Redux/Slices/payments/PaymentSlice";
import {
  addClient,
  addToPanier,
  confirmOrder,
  ReservationToPanier,
  resetPanier,
  SelectedOrders,
  setClientRemise,
  setNetPriceArticle,
  setOperationType,
  setOrderid,
} from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import { useNavigate } from "react-router-dom";
import OnlineOrderInvoice from "./OnlineOrderInvoice";
import { OrderType } from "../../../_App/Types/Entites/Orders/OrderType";
import OrderStatusPopUp from "./OrderStatusPopUp";
import {
  confirmReservationApi,
  findReservationByorderId,
} from "../../../_App/Redux/Slices/Reservation/ReservationSlice";
import { ToastWarning } from "../../../Shared/Toasts/ToastWarning";
import { UserDataType } from "../../../_App/Types/Forms/UserDataType";
import Select, { MultiValue } from "react-select";
import {
  findUserByOrganisationApi,
  ListUsers,
} from "../../../_App/Redux/Slices/users/userSlice";
import { Spinner } from "react-bootstrap";
import Pagination from "../../../Shared/Pagination/Pagination";
import PaginationLayout from "../../../_Layouts/Pagination/PaginationLayout";
import Swal from "sweetalert2";
import {
  findTicketsByOrganisationApi,
  initialeListTicket,
  ordersTickets,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import TicketAvance from "../TicketDeCaisse/TicketAvance";
import TicketType from "../../../_App/Types/Entites/TicketType";
import {
  findSocieteLivraison,
  SocieteLivraison,
} from "../../../_App/Redux/Slices/societe/societeSlice";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../../_App/Redux/Slices/organisations/organisationSlice";
import ModalFacture from "./ModalFacture";
import { ListNumberPagecentaines } from "../../../_App/Data/ListNumberPage";
import axios from "axios";
import ArticleListReference from "../../../_Layouts/RightBar/RightBar/cart/ArticleListReference";
import {
  findArticleByBarCode,
  findArticleRefParentApi,
} from "../../../_App/Redux/Slices/article/articleSlice";
import { findArticleDefectueuxBarCode } from "../../../_App/Redux/Slices/articledefectueux/articledefectueuxSlice";
import { ArticleType } from "../../../_App/Types/Entites/ArticleType";

const OrdersListAdmin = () => {
  const dispatch = useAppDispatch();
  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const societe_id = useAppSelector(societeId);
  const parametrage = useAppSelector(parametrageCaisse);

  const TypeInputParametrage = parametrage?.SearchCaisse;

  const [TypeInput, setTypeInput] = useState(TypeInputParametrage);
  const navigate = useNavigate();
  const selectedOrganisation = useAppSelector(SelectedOrganisation);
  const user = useAppSelector(selectUser);

  const Orders = useAppSelector(ListOrders);

  const currentpage = useAppSelector(Currentpage);
  const totalPages = useAppSelector(TotalPages);
  const totalNet = useAppSelector(TotalNet);
  const totalTTC = useAppSelector(TotalTTC);
  const montantRemises = useAppSelector(totalRemises);

  const remboursement = useAppSelector(Remboursement);
  const recette = useAppSelector(Recette);

  const listusers = useAppSelector(ListUsers);
  const [index, setindex] = useState(1);
  const [loader, setloader] = useState(false);
  //// gestion avance
  const [ticketId, setTicketId] = useState<string | null>(null);
  const [showModalTicketAvance, setShowModalTicketAvance] = useState(false);
  const [Reservation, setReservation] = useState();
  const livraison = useAppSelector(SocieteLivraison);

  /*****************filtre*************** */
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const [ShowModalListReference, setShowModalListReference] = useState(false);

  const [ListReference, setListReference] = useState<any[]>();

  interface FiltreInterface {
    organisation: any;
    societe_id: any;
    dateDebut: any;
    dateFin: any;
    listcaissiers: UserDataType[];
    listvendeur: UserDataType[];
    status: any;
    type: string;
    numOrder: any;
    index: any;
    keyword: any;
    journal_id: any;
    reference: any;
    barCode: any;
    includesRemise: boolean;
  }
  const filtreStore = localStorage.getItem("filtreVente");
  const fromPaidOrder = localStorage.getItem("fromPaidOrder");

  const [filtre, setFiltre] = useState<FiltreInterface>({
    organisation: currentOrganisation,
    dateFin: formatdate(today),
    dateDebut: formatdate(today),
    listcaissiers: [],
    listvendeur: [],
    status: "Tout",
    type: "caisse",
    numOrder: null,
    index: 1,
    keyword: "",
    societe_id: societe_id,
    journal_id: null,
    reference: "",
    barCode: "",
    includesRemise: false,
  });
  useEffect(() => {
    if (filtreStore && fromPaidOrder === "true") {
      const jsonfiltreStore: FiltreInterface = JSON.parse(filtreStore);
      setFiltre(jsonfiltreStore);
      localStorage.setItem("fromPaidOrder", "false");
    }
  }, [filtreStore]);

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSelectChangeUsers = (selectedUsers: any) => {
    const copie = { ...filtre };
    copie.listcaissiers = selectedUsers.map((item: any) => item.value);
    setFiltre(copie);
  };
  const handleSelectChangeVendeur = (selectedUsers: any) => {
    const copie = { ...filtre };
    copie.listvendeur = selectedUsers.map((item: any) => item.value);
    setFiltre(copie);
  };
  const handleSelectMultipleOrders = async () => {
    if (selectedOrders?.length) {
      await dispatch(
        SelectedOrders({
          orders: selectedOrders,
          livraison: livraison.frais_livraison,
        })
      );
      await dispatch(setOperationType({ type: "Pay", refunded: [] }));

      window.location.href = "/caisse";
    }
  };
  const handleSelectOrder = async (order: any) => {
    console.log(order);
    /*if (order.status === "reservation") {
      const findReservation = await dispatch(
        findReservationByorderId(order._id)
      );
      if (findReservation) {
        const todayDate = new Date();
        const echeanceDate = new Date(findReservation.payload?.date_echeance);

        if (todayDate <= echeanceDate) {
          if (parametrage && parametrage.barcodeOnly) {
            await dispatch(findPaymentsByOrderApi(order._id));
            console.log("findReservation", findReservation);
            await dispatch(
              selectOrder({ order_id: order._id, orderdata: order })
            );
            console.log("order", order);
            await dispatch(
              ReservationToPanier({
                avance: findReservation.payload?.avance?.reduce(
                  (accumulator: any, currentValue: any) =>
                    accumulator + currentValue.total,
                  0
                ),
                order_id: order._id,
                totalNet: findReservation.payload?.achat_totalNet,
                items: order.items,
                client: findReservation.payload?.infoclient.client,
                reservation: findReservation.payload,
              })
            );
            await dispatch(
              setClientRemise(findReservation.payload?.infoclient.client.remise)
            );
            await dispatch(setNetPriceArticle());
            // window.location.href = "/caisse";
            navigate("/caisse");
          }
        } else {
          ToastWarning("vous avez dépassé la date  d'échéance");
        }
      }
    } else*/ if ( 
      order.status === "Payée" ||
      order.status === "Avoir" ||
      order.status === "demande annulation" ||
       order.status === "demande accepter" ||
      order.status === "reservation"
    ) {
      dispatch(resetPanier(parametrage.timbreTicket || 0));
      localStorage.setItem("filtreVente", JSON.stringify(filtre));
      localStorage.setItem("fromPaidOrder", "true");
      navigate(`/PaidOrder/${order._id}`);
    } else if (
      order.status === "demande" ||
      order.status === "avance en cours de validation"
    ) {
      Swal.fire({
        title: `Commande numéro ${order.order_number}`,
        text: "est toujours en état de demande, elle n'a pas encore été traitée.",
      });
      navigate(`/avance/${order._id}`);
    } else if (order.status === "demande avance valide") {
      Swal.fire({
        title: `La demande de la commande numéro ${order.order_number} a été acceptée`,
        text: "Voulez-vous confirmer la commande ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Confirmer",
        cancelButtonText: "Annuler",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await dispatch(
            confirmReservationApi({ orderId: order._id })
          );
          if (res.payload.success) {
            const idticket = res.payload.data.ticket;
            setTicketId(idticket);
            setReservation(res.payload.data.Reservation);
            setShowModalTicketAvance(true);
          }
        } else {
          console.log("Commande annulée");
        }
      });
    } else if (
      order.status === "demande Invalide" ||
      order.status === "avance non valide"
    ) {
      Swal.fire({
        title: `Commande numéro ${order.order_number}`,
        text: "La demande n'est pas acceptée.",
      });
    }
    // else if (order.status === "Annulée" || order.status === "Avoir") {
    //   Swal.fire({
    //     title: `Commande numéro ${order.order_number}`,
    //     text: ` La demande est ${order.status}`,
    //   });
    else {
      await dispatch(addClient(order?.client_id));
      await dispatch(setOrderid(order._id));
      order.items.forEach(async (item: any) => {
        await dispatch(
          addToPanier({
            article: item.article,
            quantity: item.quantity, // Negative quantity for returns
            outOFStock: item.outOFStock,
            sold_quantity: item.sold_quantity,
            prix_unitaire: item.prix_unitaire, // Negative price for returns
            prix_total: item.prix_unitaire * item.quantity, // Total price negative
            paid_quantity: 0,
            remise: item.remise || 0,
            remisepropsition: item.remisepropsition,
            remiseClient: 0,
            type:
              order.status === "demande Valide"
                ? "defaut"
                : item?.type
                ? item.type
                : "fils",
            note: item?.note,
            prixNet: -(
              item.prix_unitaire *
              item.Qteretour *
              (item.remise / 100)
            ), // Negative net price
          })
        );
      });
      dispatch(confirmOrder());

      if (isOnlineSale) {
        await dispatch(selectOrder({ order_id: order._id, orderdata: order }));
        navigate(`/caisse/${order._id}`);
      } else {
        navigate("/caisse");
      }
    }
  };
  const isOnlineSale =
    user?.role_id?.libelle === "onlineSale" || filtre?.type === "online";
  useEffect(() => {
    getListOrder("");
  }, [
    index,
    filtre.type,
    filtre.organisation,
    filtre.status,
    filtre.includesRemise,
  ]);
function formatDateAndTime(value: string | Date) {
  // Detect date-only format YYYY-MM-DD
  const isDateOnly =
    typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);

  const dateObject = new Date(value);

  const year = dateObject.getFullYear();
  const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
  const day = dateObject.getDate().toString().padStart(2, "0");

  const hours = dateObject.getHours();
  const minutes = dateObject.getMinutes();
  const seconds = dateObject.getSeconds();

  const formattedDate = `${year}-${month}-${day}`;

  // If input was date-only → return only date
  if (isDateOnly) {
    return formattedDate;
  }

  // If time is 00:00:00 → return only date
  if (hours === 0 && minutes === 0 && seconds === 0) {
    return formattedDate;
  }

  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

  return `${formattedDate} ${formattedTime}`;
}


  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const [orgDropdownOpen, setOrgDropdownOpen] = useState(false);

  const toggleStatusDropdown = () => {
    setStatusDropdownOpen((prev) => !prev);
    setTypeDropdownOpen(false);
    setOrgDropdownOpen(false);
  };

  const toggleTypeDropdown = () => {
    setTypeDropdownOpen((prev) => !prev);
    setStatusDropdownOpen(false);
    setOrgDropdownOpen(false);
  };

  const toggleOrgDropdown = () => {
    setOrgDropdownOpen((prev) => !prev);
    setStatusDropdownOpen(false);
    setTypeDropdownOpen(false);
  };

  useEffect(() => {
    if (currentOrganisation) {
      dispatch(findUserByOrganisationApi(currentOrganisation));
      dispatch(findTicketsByOrganisationApi(currentOrganisation));
    }
    if (societe_id) {
      dispatch(findSocieteLivraison(societe_id));
      dispatch(allOrganisationsApi(societe_id));
    }
  }, [currentOrganisation, societe_id]);

  const magasins = useAppSelector(ListOrganisations);
  const types = [
    { type: "Tous", label: "Tous" },
    { type: "online", label: "En ligne" },
    { type: "caisse", label: "Caisse" },
  ];
  const magasinsFilter = [
    { name: "Tous", id: null },
    ...magasins?.map((magasin) => ({
      name: magasin.nom,
      id: magasin._id,
    })),
  ];
  const getListOrder = async (keyword: any) => {
    setFiltre((prevFiltre) => {
      const updatedFiltre = {
        ...prevFiltre,
        index: index,
        keyword: keyword,
      };

      // Dispatch with the updated filtre
      dispatch(findOrdersFiltreApi(updatedFiltre));

      return updatedFiltre;
    });
  };

  const { t } = useTranslation();
  const [facture, setFacture] = useState(false);
  const [orderId, setOrderId] = useState<String | undefined>(undefined);
  const [ticket, setTicket] = useState<String | undefined>(undefined);

  useEffect(() => {
    if (orderId) {
      setFacture(true);
    }
  }, [orderId]); // Run this effect whenever orderId changes

  const handleOpenTicket = (order_id: string, ticket: any) => {
    setOrderId(order_id); // Trigger the state change
    setTicket(ticket);
  };
  const handleCloseModal = () => {
    setFacture(false); // Close the modal
    setOrderId(""); // Optionally clear the orderId or reset it
  };
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({ id: "", status: "" });
  const handleStatusClick = (order: OrderType) => {
    setSelectedOrder({ id: order._id, status: order.status });
    setShowStatusModal(true);
  };

  // Update selected status
  const handleStatusChange = (newStatus: any) => {
    setSelectedOrder((prev) => ({ ...prev, status: newStatus }));
  };

  const UsersOptions = listusers?.map((option) => ({
    value: option._id,
    label: option.nom + " " + option.prenom,
  }));

  const [selectMode, setSelectMode] = useState<boolean>(false);
  const [selectedOrders, setSelectedOrders] = useState<OrderType[]>([]);

  const handleSelectToggle = () => {
    setSelectMode((prev) => !prev);
    setSelectedOrders([]); // Reset selection when exiting select mode
  };
  const selectAll = () => {
    setSelectedOrders(Orders);
  };

  const handleOrderSelect = (orderId: string, orders: OrderType[]) => {
    setSelectedOrders((prev) => {
      const isSelected = prev.some((order) => order._id === orderId);

      if (isSelected) {
        return prev.filter((order) => order._id !== orderId);
      } else {
        const selectedOrder = orders.find((order) => order._id === orderId);
        return selectedOrder ? [...prev, selectedOrder] : prev;
      }
    });
  };

  const saveStatusChange = async (
    orders: OrderType[],
    choosenStatus: string
  ) => {
    Swal.fire({
      title: "Voulez-vous confirmer ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then(async (result) => {
      if (result.isConfirmed) {
        orders.map(async (item) => {
          const res = await dispatch(
            updateOrderApi({
              orderId: item._id,
              status: choosenStatus,
              paidProducts: [],
              vendeur: null,
            })
          );
          if (res.payload.success) {
            setSelectMode(false);
          }
        });
      }
    });
  };
  const lastKeyPressTime = useRef<number>(0);

  const handleChange = (e: any) => {
    const { value } = e.target;
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        getListOrder(value);
      },
      isScannerInput ? 100 : 2000
    );
  };
  const handleBarcodeChange = (e: any) => {
    const { value } = e.target;
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;

    const isScannerInput = timeDiff < 50;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        setFiltre((prev) => ({
          ...prev,
          barCode: value,
          reference: "", // Clear reference when searching by barcode
        }));
        // Dispatch the search with updated filtre
        dispatch(
          findOrdersFiltreApi({
            ...filtre,
            barCode: value,
            reference: "",
          })
        );
      },
      isScannerInput ? 100 : 2000
    );
  };

  useEffect(() => {
    // Ajout de l'écouteur lors du montage
    const handleKeyPress = (e: any) => {
      const currentElement = document.activeElement;
      // Si l'élément actif n'est pas un champ input,
      // alors on redirige le focus vers l'input "code_input"
      if (currentElement && currentElement.tagName.toLowerCase() !== "input") {
        const myInputElement = document.getElementById("code_input");
        if (myInputElement) {
          myInputElement.focus();
        }
      }
    };

    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);
  const getSpecialProcessTicket = (tickets: TicketType[], order: OrderType) => {
    const hasEchange = tickets.some((ticket) => ticket.process === "Echange");
    const hasRetour =
      tickets.some((ticket) => ticket.process === "Retour") ||
      order.status === "Retour";

    if (hasEchange && hasRetour) {
      return "Echange&Retour"; // Both exist
    } else if (hasEchange) {
      return "Echange"; // Only Echange exists
    } else if (hasRetour) {
      return "Retour"; // Only Retour exists
    } else {
      return null; // No special process tickets
    }
  };
  const [showModal, setShowModal] = useState(false);

  const printReceipt = async () => {
    const receiptData = {
      items: [
        { name: "Coffee", price: 3.5 },
        { name: "Sandwich", price: 7.0 },
      ],
    };

    try {
      const response = await axios.post("adressMac/print", receiptData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200) {
        alert("Receipt sent to printer!");
      } else {
        alert("Print failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Print failed.");
    }
  };

  const [ReferenceArticle, setReferenceArticle] = useState<any>();
  const handleInputChange = async (inputValue: any) => {
    const resultReference = await dispatch(
      findArticleRefParentApi({ ref: inputValue, societe_id: societe_id })
    );

    // const resultBon = await dispatch(findBonByBarcode(inputValue));
    if (resultReference.payload) {
      const list = resultReference?.payload?.map((e: any) => {
        return { article: e };
      });
      setListReference(list);
      setShowModalListReference(true);
    }
    setTypeInput(TypeInputParametrage);
  };
  useEffect(() => {
    if (ReferenceArticle) {
      const newFiltre = {
        ...filtre,
        reference: ReferenceArticle?.article?._id,
      };

      // Update state immediately
      setFiltre(newFiltre);

      // Then dispatch with the updated filtre
      dispatch(findOrdersFiltreApi(newFiltre));
    }
  }, [ReferenceArticle]);
  return (
    <>
      {" "}
      <div className="row layout-spacing">
        <div className=" row statbox widget box box-shadow">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="col-11">
              {" "}
              <h3>
                {t("Orders List")}
                {filtre.type === "online" ? " en ligne" : " caisse"}{" "}
              </h3>
            </div>
            <div className="col-1">
              <button
                className="btn btn-info"
                onClick={() => setShowModal(true)}
              >
                Produits
              </button>
            </div>
          </div>
          <div className="row">
            <div className="search-bar col-6" style={{ position: "relative" }}>
              {" "}
              <input
                autoFocus
                style={{
                  background: "#f1f2f3",
                  border: "none",
                  paddingRight: "70px", // add space for the button
                }}
                type="text"
                id="code_input"
                className="form-control"
                placeholder={t("scan ticket")}
                onChange={handleChange}
              />
            </div>
            <div className="search-bar col-6" style={{ position: "relative" }}>
              <input
                autoFocus
                style={{
                  background: "#f1f2f3",
                  border: "none",
                  paddingRight: "70px", // add space for the button
                }}
                type="text"
                id="code_input"
                className="form-control"
                placeholder={t("scan article")}
                onChange={(e) => {
                  if (TypeInput === "codeBarre") {
                    handleBarcodeChange(e);
                  } else {
                    handleInputChange(e.target.value);
                    // handleReferenceChange(e);
                  }
                }}
              />
              <button
                className="btn btn-primary"
                onClick={() =>
                  setTypeInput(TypeInput === "codeBarre" ? "ref" : "codeBarre")
                }
                style={{
                  position: "absolute",
                  right: "18px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "4px 10px",
                }}
              >
                {TypeInput === "codeBarre" ? "CB" : "REF"}
              </button>
            </div>
          </div>

          <div className="row mt-3 mb-3 orders-filter">
            <div className=" col-lg-1 col-sm-6  col-md-6">
              <div className="search-bar">
                <input
                  style={{ background: "#f1f2f3", border: "none" }}
                  type="text"
                  className="form-control "
                  placeholder={t("search")}
                  value={filtre.numOrder}
                  onChange={(e) =>
                    setFiltre((prev) => ({
                      ...prev,
                      numOrder: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <input
              type="Date"
              className="form-control col-lg-2  col-sm-6  col-md-6"
              style={{
                background: "#f1f2f3",
                border: "none",
                width: "auto",
                height: "auto",
              }}
              id="datepicker"
              value={filtre.dateDebut}
              onChange={(e) =>
                setFiltre((prev) => ({
                  ...prev,
                  dateDebut: e.target.value,
                }))
              }
            />{" "}
            <input
              type="Date"
              className="form-control col-lg-2  col-sm-6  col-md-6"
              style={{
                background: "#f1f2f3",
                border: "none",
                width: "auto",
                height: "auto",
              }}
              id="datepicker"
              value={filtre.dateFin}
              onChange={(e) =>
                setFiltre((prev) => ({
                  ...prev,
                  dateFin: e.target.value,
                }))
              }
            />{" "}
            <Select
              isMulti
              options={UsersOptions}
              isSearchable={true}
              placeholder="caissiers"
              className="col-lg-1    col-sm-1"
              onChange={(newSelectedOptions) =>
                handleSelectChangeUsers(newSelectedOptions)
              }
            />
            <Select
              isMulti
              options={UsersOptions}
              isSearchable={true}
              placeholder="vendeurs"
              className=" col-lg-1  col-sm-1"
              onChange={(newSelectedOptions) =>
                handleSelectChangeVendeur(newSelectedOptions)
              }
            />
            <div
              className=" col-lg-1  col-sm-6  col-md-6 "
              onClick={toggleStatusDropdown}
              style={{ display: "flex", justifyContent: "right" }}
            >
              <div
                className={
                  "dropdown custom-dropdown-icon " + statusDropdownOpen
                }
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={statusDropdownOpen}
                  style={{ width: "100%" }}
                >
                  <span> {t(filtre.status)} </span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={
                    "dropdown-menu dropdown-menu-right " + statusDropdownOpen
                  }
                  aria-labelledby="customDropdown"
                >
                  {statusList?.map(({ status, label }, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      data-value={label} // If needed for tracking
                      onClick={() =>
                        setFiltre((prev) => ({
                          ...prev,
                          status: status,
                        }))
                      }
                    >
                      {t(label)} {/* Assuming t is for translation */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className=" col-lg-1  col-sm-6  col-md-6 "
              onClick={toggleTypeDropdown}
              style={{ display: "flex", justifyContent: "right" }}
            >
              <div
                className={"dropdown custom-dropdown-icon " + typeDropdownOpen}
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={typeDropdownOpen}
                  style={{ width: "100%" }}
                >
                  <span>
                    {" "}
                    {filtre.type === "online"
                      ? "En ligne"
                      : filtre.type === "Tous"
                      ? "Tous"
                      : "Caisse"}{" "}
                  </span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={
                    "dropdown-menu dropdown-menu-right " + typeDropdownOpen
                  }
                  aria-labelledby="customDropdown"
                >
                  {types?.map(({ type, label }, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      data-value={label} // If needed for tracking
                      onClick={() =>
                        setFiltre((prev) => ({
                          ...prev,
                          type: type,
                        }))
                      }
                    >
                      {t(label)} {/* Assuming t is for translation */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className=" col-lg-1  col-sm-6  col-md-6 "
              onClick={toggleOrgDropdown}
              style={{ display: "flex", justifyContent: "right" }}
            >
              <div
                className={"dropdown custom-dropdown-icon " + orgDropdownOpen}
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={orgDropdownOpen}
                  style={{ width: "100%" }}
                >
                  <span>
                    {" "}
                    {
                      magasinsFilter?.find(
                        (magasin) => filtre.organisation === magasin.id
                      )?.name
                    }{" "}
                  </span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={
                    "dropdown-menu dropdown-menu-right " + orgDropdownOpen
                  }
                  aria-labelledby="customDropdown"
                >
                  {magasinsFilter?.map(({ name, id }, index) => (
                    <div
                      key={index}
                      className="dropdown-item"
                      data-value={name} // If needed for tracking
                      onClick={() =>
                        setFiltre((prev) => ({
                          ...prev,
                          organisation: id,
                        }))
                      }
                    >
                      {name} {/* Assuming t is for translation */}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div
              className=" col-lg-1  col-sm-6  col-md-6 "
              onClick={toggleTypeDropdown}
              style={{ display: "flex", justifyContent: "right" }}
            >
              <div
                className={"dropdown custom-dropdown-icon " + typeDropdownOpen}
                style={{ cursor: "pointer" }}
              >
                <a
                  className="dropdown-toggle btn"
                  href="#"
                  role="button"
                  id="customDropdown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={typeDropdownOpen}
                  style={{ width: "100%" }}
                >
                  <span>
                    {" "}
                    {/* {filtre.type === "online"
                      ? "En ligne"
                      : filtre.type === "Tous"
                      ? "Tous"
                      : "Caisse"}{" "} */}
                  </span>{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-chevron-down"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </a>
                <div
                  className={
                    "dropdown-menu dropdown-menu-right " + typeDropdownOpen
                  }
                  aria-labelledby="customDropdown"
                >
                  {ListNumberPagecentaines.map((item) => (
                    <div key={index} className="dropdown-item">
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <span className="col-lg-1 " onClick={() => getListOrder("")}>
              <button className="btn btn-success">
                {" "}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    fill="#ffffff"
                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6 .1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                  />
                </svg>
              </button>
            </span>
          </div>

          <div
            className="widget-content widget-content-area"
            style={{ overflowX: "auto", border: "none", boxShadow: "none" }}
          >
            <nav id="payment-block">
              <ul className="menu-payments_vente" style={{ flexWrap: "wrap" }}>
                <li className="menu active">
                  <a
                    data-active="true"
                    className="menu-toggle"
                    style={{
                      borderColor: "#009688", // Change to the desired background color
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">{t("Total TTC")}</div>
                      <span> {totalTTC?.toFixed(3)} TND</span>
                    </div>
                  </a>
                </li>
                <li className="menu">
                  <a
                    data-active="true"
                    className="menu-toggle"
                    onClick={() => {
                      const newIncludesRemise = !filtre.includesRemise;
                      setFiltre((prev) => ({
                        ...prev,
                        includesRemise: newIncludesRemise,
                      }));
                    }}
                    style={{
                      backgroundColor: filtre.includesRemise
                        ? "#009688"
                        : "#0096881c",
                      color: filtre.includesRemise ? "white" : "inherit",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      borderColor: "#009688",
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">{t("Montant remises")}</div>
                      <span
                        style={{
                          color: filtre.includesRemise ? "white" : "#009688",
                        }}
                      >
                        {montantRemises?.toFixed(3)} TND
                      </span>
                    </div>
                  </a>
                </li>

                <li className="menu active">
                  <a
                    data-active="true"
                    className="menu-toggle"
                    style={{
                      borderColor: "#009688", // Change to the desired background color
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">{t("Total Net")}</div>
                      <span> {totalNet?.toFixed(3)} TND</span>
                    </div>
                  </a>
                </li>
                {filtre?.type === "online" && (
                  <li className="menu active">
                    <a
                      data-active="true"
                      className="menu-toggle"
                      style={{
                        borderColor: "#009688", // Change to the desired background color
                      }}
                    >
                      <div className="base-menu">
                        <div className="base-icons">Frais Livraison</div>
                        <span> {remboursement?.toFixed(3)} TND</span>
                      </div>
                    </a>
                  </li>
                )}
                <li className="menu active">
                  <a
                    data-active="true"
                    className="menu-toggle"
                    style={{
                      borderColor: "#009688", // Change to the desired background color
                    }}
                  >
                    <div className="base-menu">
                      <div className="base-icons">{t("Recette")}</div>
                      <span> {recette?.toFixed(3)} TND</span>
                    </div>
                  </a>
                </li>
              </ul>
            </nav>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "right",
                marginBottom: "5px",
              }}
            >
              {isOnlineSale && (
                <div className="col-2">
                  {" "}
                  {selectMode ? (
                    <button
                      className="btn btn-primary"
                      onClick={selectAll}
                      style={{ height: "fit-content" }}
                    >
                      Sélectionner tous
                    </button>
                  ) : null}
                  <button
                    className={
                      selectMode ? "btn btn-danger" : "btn btn-primary"
                    }
                    onClick={handleSelectToggle}
                    style={{ height: "fit-content" }}
                  >
                    {selectMode ? "Annuler" : "Sélectionner"}
                  </button>
                </div>
              )}
            </div>
            {user &&
            user.role_id?.libelle === "onlineSale" &&
            selectedOrders?.length &&
            selectMode ? (
              <div className="row">
                <div className="col-2" onClick={() => console.log(Orders)}>
                  {" "}
                  Status commande
                </div>
                {!Orders?.some((item) => item.status === "Pre-confirmée") ? (
                  <>
                    <div className="col-2">
                      {" "}
                      <button
                        className="btn btn-primary mb-2"
                        onClick={() =>
                          saveStatusChange(selectedOrders, "En livraison")
                        }
                        style={{ height: "fit-content", width: "100%" }}
                      >
                        En livraison
                      </button>
                    </div>

                    <div className="col-2">
                      {" "}
                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          saveStatusChange(selectedOrders, "Retour")
                        }
                        style={{ height: "fit-content", width: "100%" }}
                      >
                        Retour
                      </button>
                    </div>

                    <div className="col-2">
                      {" "}
                      <button
                        className="btn btn-success"
                        onClick={handleSelectMultipleOrders}
                        style={{ height: "fit-content", width: "100%" }}
                      >
                        Payer
                      </button>
                    </div>
                  </>
                ) : null}
                <div className="col-2">
                  {" "}
                  <button
                    className="btn btn-danger"
                    onClick={() => saveStatusChange(selectedOrders, "Annulée")}
                    style={{ height: "fit-content", width: "100%" }}
                  >
                    Annulée
                  </button>
                </div>
              </div>
            ) : null}

            <table id="style-2" className="table style-2  table-hover">
              <thead>
                <tr>
                  <th
                    className="checkbox-column dt-no-sorting"
                    style={{ fontSize: "15px" }}
                  >
                    {t("N° commande")}
                  </th>
                  <th style={{ fontSize: "15px" }}>{t("Date")}</th>
                  {selectedOrganisation &&
                    selectedOrganisation?.Type?.table && (
                      <th style={{ fontSize: "15px" }}>{t("Table")}</th>
                    )}
                  <th style={{ fontSize: "15px" }}>{t("client")}</th>
                  {<th style={{ fontSize: "15px" }}>{t("Magasin")}</th>}{" "}
                  <th style={{ fontSize: "15px" }}>{t("Type")}</th>
                  <th style={{ fontSize: "15px" }}>{t("total")}</th>
                  <th style={{ fontSize: "15px" }}>{t("Remise")}</th>
                  <th style={{ fontSize: "15px" }}>{t("total net")}</th>
                  <th className="text-center" style={{ fontSize: "15px" }}>
                    {t("status")}
                  </th>
                  <th className="text-center" style={{ fontSize: "15px" }}>
                    {t("facture")}
                  </th>
                </tr>
              </thead>
              {loader ? (
                <Spinner />
              ) : (
                <tbody>
                  {Orders && Orders?.length > 0 && (
                    <>
                      {Orders.map((item) => {
                        // Check if the item has a ticket with 'echange' or 'retour' process
                        const specialProcess = getSpecialProcessTicket(
                          item.tickets || [],
                          item
                        );

                        return (
                          <tr key={item._id}>
                            <td
                              className="checkbox-column"
                              style={{ fontSize: "15px", position: "relative" }}
                            >
                              <input
                                type="checkbox"
                                checked={selectedOrders.includes(item)}
                                onChange={() =>
                                  handleOrderSelect(item._id, Orders)
                                }
                                style={{
                                  marginRight: "5px",
                                  display: selectMode ? "unset" : "none",
                                }}
                              />

                              <a
                                className="link"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={(e) => handleSelectOrder(item)}
                              >
                                {item.order_number}
                                {/* Render badge in the top-right corner of the table cell */}
                                {specialProcess && (
                                  <span
                                    className="shadow-none badge badge-warning"
                                    style={{
                                      position: "absolute", // Position relative to the <td> (now it's the parent)
                                      top: "5px", // Adjust to move it down slightly
                                      right: "5px", // Move it to the right side
                                      padding: "2px 6px",
                                      fontSize: "12px",
                                      borderRadius: "4px",
                                      backgroundColor: "#f39c12", // Customize the badge color
                                      color: "white",
                                    }}
                                  >
                                    {specialProcess}{" "}
                                  </span>
                                )}
                              </a>
                            </td>

                            <td style={{ fontSize: "15px" }}>
                              {formatDateAndTime(item.createdAt)}
                            </td>
                            {selectedOrganisation?.Type?.table && (
                              <td style={{ fontSize: "15px" }}>
                                {item.table_id?.numero || 1}
                              </td>
                            )}
                            <td style={{ fontSize: "15px" }}>
                              {item.client_id?.nom}
                            </td>
                            <td style={{ fontSize: "15px" }}>
                              {item.organisation_id?.nom}
                            </td>
                            <td style={{ fontSize: "15px" }}>
                              {item.type === "caisse" ? "Caisse" : "En ligne "}
                            </td>
                            <td style={{ fontSize: "15px" }}>
                              {item.total.toFixed(3)}
                            </td>
                            <td style={{ fontSize: "15px" }}>
                              {item.montant_remise?.toFixed(3)}
                            </td>
                            <td
                              className="checkbox-column"
                              style={{ fontSize: "15px", position: "relative" }}
                            >
                              <p
                                style={{
                                  cursor: "pointer",
                                  marginBottom: 0,
                                }}
                              >
                                {item?.totalNet?.toFixed(3)}
                                {/* Render badge in the top-right corner of the table cell */}
                                {(specialProcess ||
                                  item.status === "Avoir") && (
                                  <span
                                    className="shadow-none badge badge-danger"
                                    style={{
                                      position: "absolute", // Position relative to the <td> (now it's the parent)
                                      top: "5px", // Adjust to move it down slightly
                                      right: "5px", // Move it to the right side
                                      padding: "2px 6px",
                                      fontSize: "12px",
                                      borderRadius: "4px",
                                      color: "white",
                                    }}
                                  >
                                    {item.perteRetour && item.perteRetour > 0
                                      ? -item.perteRetour + " TND"
                                      : ""}
                                  </span>
                                )}
                              </p>
                            </td>
                            <td
                              className="text-center"
                              style={{ fontSize: "15px" }}
                            >
                              <span
                                className={
                                  item.status === "Nouvelle"
                                    ? "shadow-none badge badge-info"
                                    : item.status === "En attente" ||
                                      item.status === "En cours"
                                    ? "shadow-none badge badge-warning"
                                    : item.status === "Payée"
                                    ? "shadow-none badge badge-success"
                                    : item.status === "Partiellement payée"
                                    ? "shadow-none badge badge-danger"
                                    : item.status === "En livraison"
                                    ? "shadow-none badge badge-primary"
                                    : "shadow-none badge badge-danger"
                                }
                                style={{
                                  width: "100%",
                                  height: "25px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "15px",
                                  cursor: "pointer",
                                }}
                                onClick={() => console.log(item)}
                              >
                                {t(item.status)}
                              </span>
                            </td>
                            <td
                              style={{ textAlign: "center", display: "grid" }}
                            >
                              {isOnlineSale ? (
                                item.status !== "Pre-confirmée" &&
                                item.tickets
                                  ?.filter(
                                    (ticket) =>
                                      ticket.process === "Echange" ||
                                      ticket.process === "Online"
                                  )
                                  .map((ticket, index) => (
                                    <a
                                      onClick={() => {
                                        ticket &&
                                          ticket._id &&
                                          handleOpenTicket(
                                            item._id,
                                            ticket?._id
                                          );
                                      }}
                                      key={index}
                                      className="link"
                                      style={{ cursor: "pointer" }}
                                    >
                                      {"facture "}{" "}
                                      {ticket.process === "Online"
                                        ? "Vente"
                                        : ticket.process}
                                    </a>
                                  ))
                              ) : (
                                <a
                                  className="link"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleOpenTicket(item._id, null)
                                  }
                                >
                                  {"facture"}
                                </a>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  )}
                </tbody>
              )}
            </table>
          </div>
          <PaginationLayout
            index={index}
            nbrpage={currentpage}
            totalpages={totalPages}
            setindex={setindex}
          />
          <ArticleListReference
            t={t}
            ShowModal={ShowModalListReference}
            setShowModal={setShowModalListReference}
            selectAricle={setReferenceArticle}
            list={ListReference}
            reference={""}
          />
        </div>
      </div>
      {ticketId ? (
        <>
          <TicketAvance
            ShowModal={showModalTicketAvance}
            setShowModal={setShowModalTicketAvance}
            ticket={ticketId}
            reservation={Reservation}
          />
        </>
      ) : null}
      <OnlineOrderInvoice
        order_id={orderId}
        ticket={ticket}
        show={facture}
        setShow={setFacture}
        onClose={handleCloseModal} // Pass the close handler to reset the state
        orderstype={filtre.type}
      />
      <OrderStatusPopUp
        show={showStatusModal}
        order={selectedOrder}
        onClose={() => setShowStatusModal(false)}
        selectedStatus={selectedOrder.status}
        onChangeStatus={handleStatusChange}
      />
      <ModalFacture
        showModal={showModal}
        setShowModal={setShowModal}
        filtre={filtre}
      />
    </>
  );
};

export default OrdersListAdmin;
